import React from 'react'
import { Typography, Stack, Radio, RadioGroup, Card } from '@mui/material'
import { numberFormat } from '@/helpers/numbers'
import { Currency, getCurrencySymbol } from '@caterdesk/utils--money'
import useTenant from '@/hooks/useTenant'

type Props = {
  currency: string
  bundle: number
  totalToPay: number
  onChange: (number: number) => void
}

const CreditSelector: React.FC<Props> = ({ bundle, onChange, totalToPay, currency }) => {
  const tenant = useTenant()
  const topupValues = tenant.features?.ccTopupAmounts?.topupValues ?? []
  const minimumTopupValue = tenant.features?.ccTopupAmounts?.minimumTopup ?? 0
  const highestTopupValue = 30

  return (
    <RadioGroup
      aria-labelledby="credit-bundle-select"
      name="credit-bundle-select"
      value={bundle}
      onChange={(e) => {
        onChange(Number(e.target.value))
      }}
    >
      <Stack width="100%" spacing={2} direction="column">
        {totalToPay >= minimumTopupValue && (
          <Stack spacing={1} direction="column">
            <Typography color="text.secondary" variant="body2">
              Just what you need
            </Typography>
            <Card>
              <Stack
                paddingX={1}
                paddingY={1}
                paddingRight={2}
                alignItems="center"
                direction="row"
                width="100%"
              >
                <Radio value={0} />
                <Stack
                  alignItems="center"
                  width="100%"
                  direction="row"
                  justifyContent="space-between"
                >
                  <Typography variant="body1">Buy {numberFormat(totalToPay)} credits</Typography>
                  <Typography variant="body1">
                    {getCurrencySymbol(currency as Currency)}
                    {numberFormat(totalToPay)}
                  </Typography>
                </Stack>
              </Stack>
            </Card>
          </Stack>
        )}
        <Stack direction="column" spacing={1}>
          {totalToPay < highestTopupValue && (
            <Typography color="text.secondary" variant="body2">
              {totalToPay >= minimumTopupValue
                ? 'Credit bundle'
                : `Minimum payment ${getCurrencySymbol(currency as Currency)}${minimumTopupValue}. Please select a bundle.`}
            </Typography>
          )}
          <Card>
            {topupValues.map((topUpValue) =>
              topUpValue && (totalToPay < topUpValue || minimumTopupValue) ? (
                <Stack
                  key={topUpValue}
                  paddingX={1}
                  paddingY={1}
                  paddingRight={2}
                  alignItems="center"
                  direction="row"
                  width="100%"
                >
                  <Radio value={topUpValue} />
                  <Stack
                    alignItems="center"
                    width="100%"
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Typography variant="body1">Buy {numberFormat(topUpValue)} credits</Typography>
                    <Typography variant="body1">
                      {getCurrencySymbol(currency as Currency)}
                      {numberFormat(topUpValue)}
                    </Typography>
                  </Stack>
                </Stack>
              ) : null,
            )}
          </Card>
        </Stack>
      </Stack>
    </RadioGroup>
  )
}

export default CreditSelector
